// extracted by mini-css-extract-plugin
module.exports = {"remittanceStatusFilter":"CODRemittance_remittanceStatusFilter__3HCMC","topRow":"CODRemittance_topRow__28NXo"};